module.exports = __webpack_public_path__ + "static/media/designsystem.389dddd2.svg";